import React from "react"
import { Spin } from "antd"

export default ({ loading }) => {
  if (loading) {
    return (
      <div className="loading">
        <Spin />
      </div>
    )
  }
  return null
}
